<template>
  <q-form ref="form" class="full-width q-px-md">
    <div class="row">
      <div v-if="!forCompetition" class="col-12">
        <h6 class="q-my-none q-mt-xs">General</h6>
      </div>
      <div v-if="forCompetition" class="col-12">
        <q-checkbox label="Create New Division" v-model="useNew"></q-checkbox>
      </div>
      <div v-if="forCompetition && !useNew" class="col-12 q-px-xs">
        <assignDivision :id="selectedDivision" @changed="updateDivision" />
      </div>
      <div v-if="!forCompetition || useNew" class="col-12 q-pa-xs">
        <q-input
          v-model="formData.division_name"
          label="Division Name"
          v-bind="siteCFG.fields.general"
        >
        </q-input>
      </div>
      <div class="col-12 col-md-4 q-pa-xs">
        <q-input
          :readonly="forCompetition && !useNew"
          label="Min Division Age"
          v-model="formData.division_age_min"
          v-bind="siteCFG.fields.general"
        >
        </q-input>
      </div>
      <div class="col-12 col-md-4 q-pa-xs">
        <q-input
          :readonly="forCompetition && !useNew"
          label="Min Age"
          v-model="formData.age_min"
          v-bind="siteCFG.fields.general"
        >
        </q-input>
      </div>
      <div class="col-12 col-md-4 q-pa-xs">
        <q-input
          :readonly="forCompetition && !useNew"
          v-model="formData.age_max"
          label="Max Age"
          v-bind="siteCFG.fields.general"
        >
        </q-input>
      </div>
      <div class="col-12 col-md-4 q-pa-xs">
        <q-select
          :readonly="forCompetition && !useNew"
          v-model="formData.gender"
          label="Gender"
          v-bind="siteCFG.fields.general"
          :options="genderTypes"
          option-label="label"
          option-value="value"
          emit-value
          map-options
        >
        </q-select>
      </div>

      <div class="col-12 col-md-4 q-pa-xs">
        <q-input
          :readonly="forCompetition && !useNew"
          v-model="formData.minCombinedAge"
          label="Min Combined Age"
          v-bind="siteCFG.fields.general"
        >
        </q-input>
      </div>
      <div class="col-12 col-md-4 q-pa-xs">
        <q-input
          :readonly="forCompetition && !useNew"
          v-model="formData.maxCombinedAge"
          label="Max Combined Age"
          v-bind="siteCFG.fields.general"
        >
        </q-input>
      </div>
      <div class="col-12 q-pa-xs">
        <q-input
          v-model="formData.sort_order"
          label="Sorting #"
          v-bind="siteCFG.fields.general"
        ></q-input>
      </div>
    </div>
  </q-form>
</template>

<script>
  import { mapGetters } from "vuex";
  import assignDivision from "@/components/divisions/assignDivision.vue";

  export default {
    components: { assignDivision },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        siteCFG: "settings/siteCFG",
        genderTypes: "settings/genderTypes",
        data: "divisions/current",
        dataLoading: "divisions/currentLoading",
        divisions: "divisions/list",
      }),
    },
    props: {
      id: {
        default: null,
      },
      forCompetition: {
        default: false,
        type: Boolean,
      },
    },
    watch: {
      id: function () {
        this.init();
      },
      data: function () {
        this.init();
      },
    },
    data: () => ({
      // Extra Data
      formData: {},
      tab: "general",

      useNew: false,
      selectedDivision: null,
    }),
    beforeCreate() {},
    mounted() {
      this.init();
      this.$store.dispatch("divisions/loadByID", this.id);
    },
    methods: {
      init() {
        if (this.data != null && this.data.id == this.id) {
          this.formData = JSON.parse(JSON.stringify(this.data));
        } else {
          this.formData = {};
        }
      },
      create() {
        this.$emit("loadingStateChanged", true);
        this.$refs.form.validate().then((result) => {
          if (result) {
            this.$store
              .dispatch("divisions/new", this.formData)
              .then((result) => {
                this.$emit("loadingStateChanged", false);
                if (result.Result == "Success") {
                  this.$emit("close", true);
                  this.formData = {};
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: result.Response.Message,
                  });
                } else {
                  this.$q.notify({
                    position: "top-right",
                    type: "negative",
                    message: result.Response.Message,
                  });
                }
              });
          } else {
            this.$emit("loadingStateChanged", false);
          }
        });
      },
      save() {
        this.$emit("loadingStateChanged", true);

        this.$store.dispatch("divisions/save", this.formData).then((result) => {
          this.$emit("loadingStateChanged", false);
          if (result.Result == "Success") {
            this.address = "";
            this.$emit("close", true);
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        });
      },
      updateDivision(id) {
        this.selectedDivision = id;
        this.formData = this.divisions.find((d) => d.id == id);
      },
      addCompetitionToDivision(id) {
        this.$emit("loadingStateChanged", true);
        let payload = this.formData;
        if (this.useNew && payload.id) {
          delete payload.id;
        }
        payload.competitions_id = id;
        this.$store
          .dispatch("divisions/addToCompetition", payload)
          .then((result) => {
            this.$emit("loadingStateChanged", false);
            if (result.Result == "Success") {
              this.address = "";
              this.$emit("close", true);
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .formSubTitle {
    font-weight: bold;
  }
</style>
